export default {
  listHeaders() {
    return [
      { text: 'MRF No', value: 'mrF_No' },
      { text: 'MRF Tarihi', value: 'mrF_Tarihi' },
      { text: 'Proje', value: 'proje' },
      { text: 'Açıklama', value: 'aciklama' },
      { text: 'Teslim Şekli', value: 'teslim_sekli' },
      { text: 'Durumu', value: 'onay_Durumu' },
      { text: 'Reddet', value: 'Buttons' },
      { text: 'Onayla', value: 'Buttons' }
    ];
  },
};